import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Lietuvi\u0173",
  code: "lt",
  messages: {
    inputMenu: {
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173",
      noData: "N\u0117ra duomen\u0173",
      create: "Sukurti \u201E{label}\u201C"
    },
    calendar: {
      prevYear: "Ankstesni metai",
      nextYear: "Kiti metai",
      prevMonth: "Ankstesnis m\u0117nuo",
      nextMonth: "Kitas m\u0117nuo"
    },
    inputNumber: {
      increment: "Padidinti",
      decrement: "Suma\u017Einti"
    },
    commandPalette: {
      placeholder: "\u012Eveskite komand\u0105 arba ie\u0161kokite...",
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173",
      noData: "N\u0117ra duomen\u0173",
      close: "U\u017Edaryti"
    },
    selectMenu: {
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173",
      noData: "N\u0117ra duomen\u0173",
      create: "Sukurti \u201E{label}\u201C",
      search: "Ie\u0161koti..."
    },
    toast: {
      close: "U\u017Edaryti"
    },
    carousel: {
      prev: "Atgal",
      next: "Pirmyn",
      goto: "Eiti \u012F skaidr\u0119 {slide}"
    },
    modal: {
      close: "U\u017Edaryti"
    },
    slideover: {
      close: "U\u017Edaryti"
    },
    alert: {
      close: "U\u017Edaryti"
    },
    table: {
      noData: "N\u0117ra duomen\u0173"
    }
  }
});
